import React, {useEffect, useState} from 'react';
import _ from "lodash";
import {getAllDesignInfo, getSingleDesignInfo, updateSingleDesignInfo} from "../../services/design-info-data.service";
import DesignInfoFilters from "./design-info-filters";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import ShowEmptyListMessage from "../../../design/components/common/show-empty-list-message";
import {DESIGN_INFO_FIELDS_LIST, DESIGN_INFO_IDS, DESIGN_INFO_KEYS} from "../../constants/design-info.constant";
import {showDateTime} from "../../../printful/utils/printful-util";
import {setDataInLocalStorage, getDataFromLocalStorage} from "../../../common/utils/local-storage-util";
import {getAllTags} from "../../../common/services/tag-data-service";
import {Bars3BottomLeftIcon, PlusIcon, WrenchScrewdriverIcon} from "@heroicons/react/24/solid";
import {
    getAllDesigns,
    getSingleDesignById,
    searchDesigns, updateDesigns,
    updateSingleDesign
} from "../../../design/services/design-data-service";
import {getSingleQuoteById} from "../../../common/services/quote-data-service";
import {getSingleParentProductById, searchParentProducts} from "../../../pod/services/parent-product-data-service";
import {prepareDesignTags} from "../../../design/utils/design-tag-util";
import {
    prepareGenericJSONPromptMessages,
    prepareProductDescriptionMetaPromptMessages,
    prepareProductMetaTitlePromptMessages
} from "../../../design/utils/open-ai-prompt-util";
import {generateContent, generateJsonContent} from "../../../common/services/open-ai-service";
import {bulkUpdateDesignContent} from "../../../common/services/cloud-function-service";
import {
    addSingleDesignSync,
    searchDesignSyncsWithSearchCriteria,
    updateSingleDesignSync
} from "../../services/design-sync-data-service";
import AddEditImageMedia from "../../../marketing/components/media-editor/add-edit-image-media";
import CopyDataToClipboard from "../../../common/ui/copy-data-to-clipboard";
import {PRODUCT_BLOG_POST_PROMPTS} from "../../constants/product-blog-post.constant";
import {prepareTitlePromptText} from "../../utils/product-blog-post-util";
import {getSingleDesignProduct} from "../../services/design-product-data.service";
import {getCurrentDesignSyncByType} from "../../utils/design-sync-util";
import {getCurrentPinterestPinSyncByType} from "../../../pinterest/utils/pinterest-sync-util";
import {updateSinglePinterestPinSync} from "../../../pinterest/services/pinterest-pin-sync-data.service";
import AddEditPinterestImages from "../../../marketing/components/media-editor/add-edit-pinterest-images";


const defaultFilterCriteria: any = {};

const DesignInfoList = () => {
    const [initialStep, setInitialStep] = useState(true);
    const [allDesignInfo, setAllDesignInfo] = useState(null);
    const [designList, setDesignList] = useState(null);
    const [filteredDesignList, setFilteredDesignList] = useState(null);
    const [filterCriteria, setFilterCriteria] = useState(defaultFilterCriteria);
    const [dataFetchInProgress, setDataFetchInProgress] = useState(true);
    const [allTags, setAllTags] = useState([]);
    const [selectedDesignInfo, setSelectedDesignInfo] = useState(null);
    const [syncUpdateInProgress, setSyncUpdateInProgress] = useState(false);

    useEffect(() => {
        if (initialStep) {
            setInitialStep(false);
            getAllDesignsDesignInfo();
        }
    }, [initialStep]);

    const getAllTagsList = async () => {
        const tagsList = await getAllTags();
        setAllTags(tagsList);
        return tagsList;
    }

    const getAllDesignsDesignInfo = async () => {
        setDataFetchInProgress(true);
        const allDesignInfoList = await getAllDesignInfo();
        const allDesignsDesignInfo = _.find(allDesignInfoList, {id: DESIGN_INFO_IDS.ALL_DESIGNS});
        const designInfoList = _.filter(allDesignInfoList, (designInfo) => designInfo?.id !== DESIGN_INFO_IDS.ALL_DESIGNS);

        setAllDesignInfo(allDesignsDesignInfo);

        const allDesigns = _.orderBy(designInfoList, ['productType', 'category', 'name'], ['asc', 'asc', 'asc']);

        setDesignList(allDesigns);
        setFilteredDesignList(allDesigns);
        setDataFetchInProgress(false);

        const existingFilters = getDataFromLocalStorage(DESIGN_INFO_KEYS.DESIGN_INFO_FILTERS);
        setFilterCriteria(existingFilters || defaultFilterCriteria);
    }

    /*const getAllDesignsDesignInfo = async () => {
        setDataFetchInProgress(true);
        const allDesignInfo = await getSingleDesignInfo(DESIGN_INFO_IDS.ALL_DESIGNS);
        setDesignInfo(allDesignInfo);

        console.log('allDesignInfo', allDesignInfo);

        const allDesigns = _.orderBy(allDesignInfo?.designs, ['productType', 'category', 'name'], ['asc', 'asc', 'asc']);

        setDesignList(allDesigns);
        setFilteredDesignList(allDesigns);
        setDataFetchInProgress(false);

        const existingFilters = getDataFromLocalStorage(DESIGN_INFO_KEYS.DESIGN_INFO_FILTERS);
        setFilterCriteria(existingFilters || defaultFilterCriteria);
    }*/

    useEffect(() => {
        if (!_.isEmpty(designList)) {
            applyFilters();
            setDataInLocalStorage(DESIGN_INFO_KEYS.DESIGN_INFO_FILTERS, filterCriteria);
        }
    }, [filterCriteria]);

    const applyFilters = () => {
        let filteredList = [...designList];
        let existingFilterCriteria = {...filterCriteria};
        const filters = {};

        _.forEach(existingFilterCriteria, (filterValue, filterKey) => {
            if (filterValue) {
                if (filterValue === 'Yes') {
                    filters[filterKey] = true;
                } else if (filterValue === 'No') {
                    filters[filterKey] = false;
                } else {
                    filters[filterKey] = filterValue;
                }
            }
        });

        filteredList = _.filter(filteredList, filters);
        setFilteredDesignList(filteredList);
    }

    const refreshDesignInfoList = async () => {
        await getAllDesignsDesignInfo();
    }

    const handleUpdateDesignTags = async (design) => {
        setSelectedDesignInfo(design);

        const designDetail = await getSingleDesignById(design?.id);
        const quoteDetail = await getSingleQuoteById(design?.quoteId);

        let parentProductDetail;
        if (design?.parentId) {
            parentProductDetail = await getSingleParentProductById(design?.parentId);
        } else {
            const searchCriteriaList = [{
                field: 'name',
                condition: '==',
                value: design?.parent
            }];
            const parentProductList = await searchParentProducts(searchCriteriaList);
            parentProductDetail = parentProductList[0];
            designDetail.parentId = parentProductDetail?.id;
        }

        let tagsList = [...allTags];

        if (_.isEmpty(tagsList)) {
            tagsList = await getAllTagsList();
        }

        const {designTagDetailList} = prepareDesignTags(tagsList, designDetail, parentProductDetail, quoteDetail, null, null);
        designDetail.designTags = _.compact(_.uniq(_.map(designTagDetailList, 'startText')));

        await updateSingleDesign(designDetail);

        const existingDesignList = [...designList];
        const designIndex = _.findIndex(existingDesignList, {id: designDetail.id});
        const existingDesign = existingDesignList[designIndex];
        existingDesign.hasTags = true;
        existingDesignList[designIndex] = existingDesign;

        const existingDesignInfo = {...allDesignInfo};
        existingDesignInfo.designs = existingDesignList;

        await updateSingleDesignInfo(existingDesignInfo);

        setAllDesignInfo(existingDesignInfo);
        setDesignList(existingDesignList);

        setSelectedDesignInfo(null);
        applyFilters();
    }

    const generateBlogPostTitles = async (designInfo) => {
        setSelectedDesignInfo(designInfo);

        const designDetail = await getSingleDesignById(designInfo?.id);
        const designProduct = await getSingleDesignProduct(designInfo?.id);
        console.log('designDetail', designDetail);
        console.log('designProduct', designProduct);

        const blogPost: any = {
            toneOfVoice: designDetail?.toneOfVoice || 'Conversational',
        }

        const promptTitle = PRODUCT_BLOG_POST_PROMPTS.TITLE.title;
        const contentTags = _.join(designDetail?.designTags, ', ');
        const promptContent = prepareTitlePromptText(designProduct?.productsList[0]?.onlineStoreUrl, blogPost?.toneOfVoice, contentTags)
        const promptMessages = prepareGenericJSONPromptMessages(promptTitle, promptContent);
        const generatedContent: any = await generateContent(promptMessages);
        blogPost.titlesList = prepareTitles(generatedContent?.content);
        blogPost.postGenerationStatus = 'TITLES_LIST';
        designDetail.blogPost = blogPost;
        await updateSingleDesign(designDetail);

        const existingDesignInfo = {...designInfo};
        existingDesignInfo.blogPost = designDetail.blogPost || {};
        await updateSingleDesignInfo(existingDesignInfo);

        const existingDesignList = [...designList];
        const designIndex = _.findIndex(existingDesignList, {id: designInfo.id});
        existingDesignList[designIndex] = existingDesignInfo;
        setDesignList(existingDesignList);

        setSelectedDesignInfo(null);
        applyFilters();
    }

    const prepareTitles = (generatedText) => {
        let titlesText = _.replace(generatedText, /"/g, '');
        const titlesList = _.split(titlesText, '\n');

        titlesList.forEach((title, index) => {
            if (title && title.length > 0) {
                const titleWords = _.split(title, ' ');
                const firstWord = titleWords[0];

                if (_.isNumber(_.toNumber(firstWord))) {
                    titlesList[index] = _.trim(_.replace(title, firstWord, ''));
                }
            }
        });

        return titlesList;
    }

    const fixDuplicateMetaTitles = async (design, callAgainIfDuplicate = true) => {
        setSelectedDesignInfo(design);

        const designDetail = await getSingleDesignById(design?.id);
        const contentList = designDetail?.content?.contentList;

        _.forEach(contentList, (content, contentIndex) => {
            content.contentIndex = contentIndex;
        });

        const metaTitleList = _.groupBy(contentList, 'metaTitle');
        const duplicateMetaTitleList = [];
        const metaDetail = {
            count: 0,
            toneOfVoice: designDetail?.content?.toneOfVoice || 'Catchy',
            duplicateMetaTitles: []
        };

        _.forEach(metaTitleList, (metaTitleContentList, metaTitle) => {
            if (metaTitleContentList.length > 1) {
                duplicateMetaTitleList.push({
                    metaTitle,
                    total: metaTitleContentList.length
                });

                metaDetail.count += metaTitleContentList.length;
            }
        });

        metaDetail.duplicateMetaTitles = _.map(duplicateMetaTitleList, 'metaTitle');

        const promptMessages = prepareProductMetaTitlePromptMessages(designDetail, metaDetail);
        const contentDetail: any = await generateJsonContent(promptMessages);

        let newMetaTitleList = [];
        if (contentDetail.hasOwnProperty('meta_titles')) {
            newMetaTitleList = contentDetail?.meta_titles;
        } else if (contentDetail.hasOwnProperty('metaTitles')) {
            newMetaTitleList = contentDetail?.metaTitles;
        }

        let newIndex = 0
        let updatedContentList = [];
        _.forEach(metaTitleList, (metaTitleContentList, metaTitle) => {
            if (metaTitleContentList.length > 1) {
                _.forEach(metaTitleContentList, (metaTitleContent, metaTitleContentIndex) => {
                    if (newMetaTitleList?.length > 0) {
                        metaTitleContent.metaTitle = newMetaTitleList[newIndex];
                        ++newIndex;
                    }

                    updatedContentList.push(metaTitleContent)
                });
            } else {
                updatedContentList.push(metaTitleContentList[0]);
            }
        });

        updatedContentList = _.orderBy(updatedContentList, ['contentIndex'], ['asc']);

        if (updatedContentList?.length > 0) {
            designDetail.content.contentList = updatedContentList;
            const metaTitles = _.map(designDetail?.content?.contentList, "metaTitle");
            designDetail.hasDuplicateMetaTitle = _.uniq(metaTitles).length !== metaTitles.length;

            await updateSingleDesign(designDetail);

            const existingDesignList = [...designList];
            const designIndex = _.findIndex(existingDesignList, {id: designDetail.id});
            const existingDesign = existingDesignList[designIndex];
            existingDesign.hasDuplicateMetaTitle = designDetail.hasDuplicateMetaTitle;
            existingDesignList[designIndex] = existingDesign;

            const existingDesignInfo = {...allDesignInfo};
            existingDesignInfo.designs = existingDesignList;

            await updateSingleDesignInfo(existingDesignInfo);

            setAllDesignInfo(existingDesignInfo);
            setDesignList(existingDesignList);
        }

        setSelectedDesignInfo(null);
        applyFilters();

        if (designDetail.hasDuplicateMetaTitle && callAgainIfDuplicate) {
            await fixDuplicateMetaTitles(designDetail, false);
        }
    }

    const addToBulkDesignContentSync = async () => {
        setSyncUpdateInProgress(true);

        const currentFilteredDesignList = [...filteredDesignList];
        _.forEach(currentFilteredDesignList, (design) => {
            if (!design?.hasContent) {
                design.generateContent = true;
            }
        });

        const designIds = _.map(_.filter(currentFilteredDesignList, {generateContent: true}), 'id');

        const allDesignList = [...designList];
        _.forEach(allDesignList, (design) => {
            if (designIds.includes(design.id)) {
                design.generateContent = true;
            }
        });

        const currentDesignSync = await getCurrentDesignSyncByType('DESIGN-CONTENT');
        currentDesignSync.designIds = _.map(_.filter(allDesignList, {generateContent: true}), 'id');
        currentDesignSync.total = currentDesignSync.designIds.length;
        await updateSingleDesignSync(currentDesignSync);

        const existingDesignInfo = {...allDesignInfo};
        existingDesignInfo.designs = allDesignList;
        await updateSingleDesignInfo(existingDesignInfo);
        setAllDesignInfo(existingDesignInfo);

        await refreshDesignInfoList();
        setSyncUpdateInProgress(false);
    }

    const addToBulkDesignMetaTitleSync = async () => {
        setSyncUpdateInProgress(true);

        const currentFilteredDesignList = [...filteredDesignList];
        _.forEach(currentFilteredDesignList, (design) => {
            if (design?.hasDuplicateMetaTitle) {
                design.fixMetaTitle = true;
            }
        });

        const designIds = _.map(_.filter(currentFilteredDesignList, {fixMetaTitle: true}), 'id');

        const allDesignList = [...designList];
        _.forEach(allDesignList, (design) => {
            if (designIds.includes(design.id)) {
                design.fixMetaTitle = true;
            }
        });

        const currentDesignSync = await getCurrentDesignSyncByType('META-TITLE');
        currentDesignSync.designIds = _.map(_.filter(allDesignList, {fixMetaTitle: true}), 'id');
        currentDesignSync.total = currentDesignSync.designIds.length;
        await updateSingleDesignSync(currentDesignSync);

        await refreshDesignInfoList();
        setSyncUpdateInProgress(false);
    }

    const addToBulkDesignBlogPostTitleSync = async () => {
        setSyncUpdateInProgress(true);

        const currentFilteredDesignList = [...filteredDesignList];
        _.forEach(currentFilteredDesignList, (design) => {
            if (design && (!design?.blogPost || !design?.blogPost?.title)) {
                design.generateBlogPostTitles = true;
            }
        });

        const designIds = _.map(_.filter(currentFilteredDesignList, {generateBlogPostTitles: true}), 'id');

        const allDesignList = [...designList];
        _.forEach(allDesignList, (design) => {
            if (designIds.includes(design.id)) {
                design.generateBlogPostTitles = true;
            }
        });

        const currentDesignSync = await getCurrentDesignSyncByType('BLOG_POST_TITLES');
        currentDesignSync.designIds = _.map(_.filter(allDesignList, {generateBlogPostTitles: true}), 'id');
        currentDesignSync.total = currentDesignSync.designIds.length;
        await updateSingleDesignSync(currentDesignSync);

        await refreshDesignInfoList();
        setSyncUpdateInProgress(false);
    }

    const addToBulkPinterestPinSync = async () => {
        setSyncUpdateInProgress(true);

        const currentPinterestPinSync = await getCurrentPinterestPinSyncByType('PINTEREST');

        let totalVariants = currentPinterestPinSync.totalVariants || 0;
        let total = currentPinterestPinSync.total || 0;
        let designs = currentPinterestPinSync.designs || [];
        let designIds = _.map(designs, 'id') || [];
        const currentFilteredDesignList = [...filteredDesignList];

        _.forEach(currentFilteredDesignList, (design) => {
            if (!designIds.includes(design.id)) {
                if (!design.generatePinterestPin) {
                    design.generatePinterestPin = !design.generatePinterestPin;
                }

                if (design.generatePinterestPin) {
                    totalVariants += design?.totalVariants;
                    ++total;

                    designs.push({
                        id: design.id,
                        variants: design?.totalVariants
                    });
                }
            }
        });

        designIds = _.map(designs, 'id');

        const allDesignList = [...designList];
        _.forEach(allDesignList, (design) => {
            if (designIds.includes(design.id)) {
                design.generatePinterestPin = true;
            }
        });

        currentPinterestPinSync.designs = designs;
        currentPinterestPinSync.total = total;
        currentPinterestPinSync.totalVariants = totalVariants;

        await updateSinglePinterestPinSync(currentPinterestPinSync);

        console.log('currentPinterestPinSync', currentPinterestPinSync);

        await refreshDesignInfoList();
        setSyncUpdateInProgress(false);
    }

    const auditAllDesigns = async () => {
        setDataFetchInProgress(true);

        const allDesigns = await searchDesigns([], 500);

        console.log('allDesigns', allDesigns);

        const attributesMapping = {
            facebookPost: 'post',
            metaDescription: 'description',
            metaTitle: 'title',
            productDescription: 'description',
        }

        const updateDesignList = [];

        _.forEach(allDesigns, (design) => {
            let needToUpdate = false;

            _.forEach(design?.content?.contentList, (contentItem) => {
                if (_.isArray(contentItem)) {
                    console.log('--------> Design: ', design?.id, 'Name: ', design?.name, 'Content: ', contentItem);
                } else if (_.isObject(contentItem)) {
                    let hasObject = false;
                    _.forEach(contentItem, (value, key) => {
                        if (_.isArray(value)) {
                            value = value[0];
                        }

                        if (_.isObject(value)) {
                            contentItem[key] = value[attributesMapping[key]] || value['content'] || value['text'] || value['description'] || value['caption'] || value['postContent'] || value['description1'] || value;
                            hasObject = true;
                        }
                    });

                    if (hasObject) {
                        console.log('Object Attribute --------> Design: ', design?.id, 'Name: ', design?.name, 'Content: ', contentItem);
                        needToUpdate = true;
                    }
                }
            });

            if (needToUpdate) {
                updateDesignList.push(design);
            }
        });

        if (updateDesignList?.length > 0) {
            await updateDesigns(updateDesignList);
        }

        console.log('updateDesignList', updateDesignList);
        setDataFetchInProgress(false);
    }

    return (
        <>

            <div className="flex w-full justify-between items-center">

                <div className="flex w-fit justify-start items-center -ml-2">
                    <div className={'text-xl ml-2 w-48 flex'}>
                        Design Info
                        {filteredDesignList?.length > 0 &&
                            <span className={'ml-2'}>({filteredDesignList?.length})</span>
                        }
                    </div>

                    <div className={'w-full flex'}>
                        {allDesignInfo &&
                            <div className={'w-full flex justify-start items-start'}>
                                <DesignInfoFilters
                                    dataFetchInProgress={dataFetchInProgress}
                                    designs={designList}
                                    allDesignInfo={allDesignInfo}
                                    filterCriteria={filterCriteria}
                                    setFilterCriteria={setFilterCriteria}/>
                            </div>
                        }

                        <div className="mx-2">
                            <ShowProgressSpinner dataFetchInProgress={dataFetchInProgress}/>
                        </div>
                    </div>
                </div>

                <div className="w-1/4 justify-center items-center">
                    <div className={'flex justify-start items-center mb-2'}>
                        <div>
                            <button
                                className="button-purple-outline px-3 py-1 mt-1 flex items-center justify-center"
                                onClick={auditAllDesigns}>
                                <span>Fix Designs</span>
                                <span className="ml-1">
                                <ShowProgressSpinner
                                    sizeClass={'w-5 h-5'}
                                    dataFetchInProgress={dataFetchInProgress}/>
                            </span>
                            </button>
                        </div>
                        <div>
                            <button
                                className="button-outline-green px-3 py-1 mt-1 ml-2 flex items-center justify-center"
                                onClick={refreshDesignInfoList}>
                                <span>Refresh</span>
                                <span className="ml-1">
                                <ShowProgressSpinner
                                    sizeClass={'w-5 h-5'}
                                    dataFetchInProgress={dataFetchInProgress}/>
                            </span>
                            </button>
                        </div>
                    </div>

                    <div className={'justify-center items-center'}>
                        <button
                            className="button-green px-4 py-2 mt-1 flex items-center justify-center"
                            onClick={addToBulkDesignContentSync}>
                            <span>Add To Bulk Design Content Sync</span>
                            <span className="ml-1">
                                <ShowProgressSpinner
                                    sizeClass={'w-5 h-5'}
                                    dataFetchInProgress={syncUpdateInProgress}/>
                            </span>
                        </button>
                        <button
                            className="button-green px-4 py-2 mt-1 flex items-center justify-center"
                            onClick={addToBulkDesignMetaTitleSync}>
                            <span>Add To Bulk Meta Title Sync</span>
                            <span className="ml-1">
                                <ShowProgressSpinner
                                    sizeClass={'w-5 h-5'}
                                    dataFetchInProgress={syncUpdateInProgress}/>
                            </span>
                        </button>
                        <button
                            className="button-green px-4 py-2 mt-1 flex items-center justify-center"
                            onClick={addToBulkDesignBlogPostTitleSync}>
                            <span>Add To Bulk Blog Post Titles Sync</span>
                            <span className="ml-1">
                                <ShowProgressSpinner
                                    sizeClass={'w-5 h-5'}
                                    dataFetchInProgress={syncUpdateInProgress}/>
                            </span>
                        </button>

                        <button
                            className="button-green px-4 py-2 mt-1 flex items-center justify-center"
                            onClick={addToBulkPinterestPinSync}>
                            <span>Add To Bulk Pinterest Sync</span>
                            <span className="ml-1">
                                <ShowProgressSpinner
                                    sizeClass={'w-5 h-5'}
                                    dataFetchInProgress={syncUpdateInProgress}/>
                            </span>
                        </button>
                    </div>
                </div>

            </div>

            <div className="flex justify-start">

                <div
                    className="w-full bg-white mt-4">

                    <ShowEmptyListMessage
                        dataList={filteredDesignList}
                        dataFetchInProgress={dataFetchInProgress}
                        label={'Design Info'}/>

                    {filteredDesignList?.length > 0 &&
                        <div
                            className={'table-container-with-filter-2-rows overflow-y-scroll border-y border-gray-400 bg-white'}>

                            <table className="w-full">
                                <thead className="">
                                <tr>
                                    <th className="p-2 border border-gray-400 bg-gray-400 text-white sticky top-0 w-12">S.No</th>
                                    {DESIGN_INFO_FIELDS_LIST?.map((designInfoField, rowIndex) => (
                                        <th key={`th-${rowIndex}`}
                                            className={`p-2 border border-gray-400 bg-gray-400 text-white sticky top-0 text-left pl-2 ${designInfoField?.cssClass}`}>{designInfoField?.label}</th>
                                    ))}
                                    <th className="p-2 border border-gray-400 bg-gray-400 text-white text-left sticky top-0">
                                        Actions
                                    </th>
                                </tr>
                                </thead>
                                <tbody className="">
                                {filteredDesignList?.map((design, rowIndex) => (
                                    <tr key={`row-${rowIndex}`} className="border border-gray-400">
                                        <td className="p-2 border border-gray-400 m-auto">
                                            <div className="flex justify-center w-12">
                                                {rowIndex + 1}
                                            </div>
                                        </td>

                                        {DESIGN_INFO_FIELDS_LIST?.map((designInfoField, columnIndex) => (
                                            <React.Fragment key={`column-${rowIndex}-${columnIndex}`}>
                                                <td className={`p-2 border border-gray-400 m-auto ${designInfoField?.cssClass}`}>
                                                    {designInfoField?.optionsMap &&
                                                        <>{designInfoField?.optionsMap[design[designInfoField?.attribute]]?.name}</>
                                                    }

                                                    {!designInfoField?.optionsMap &&
                                                        <>
                                                            {!designInfoField?.isDate && !designInfoField?.isBoolean &&
                                                                <>
                                                                    {design[designInfoField?.attribute]}
                                                                </>
                                                            }

                                                            {designInfoField?.isDate &&
                                                                <>
                                                                    {showDateTime(design[designInfoField?.attribute])}
                                                                    {design[designInfoField?.attribute]}
                                                                </>
                                                            }

                                                            {designInfoField?.isBoolean &&
                                                                <>

                                                                    {design[designInfoField?.attribute] &&
                                                                        <span
                                                                            className={`${designInfoField?.highlightValues?.indexOf('Yes') !== -1 ? 'text-red-500 font-semibold' : ''}`}>
                                                                            Yes
                                                                        </span>
                                                                    }

                                                                    {!design[designInfoField?.attribute] &&
                                                                        <span
                                                                            className={`${designInfoField?.highlightValues?.indexOf('No') !== -1 ? 'text-red-500 font-semibold' : ''}`}>
                                                                            No</span>
                                                                    }
                                                                </>
                                                            }

                                                            {designInfoField?.secondaryAttribute &&
                                                                <div className={'text-gray-500 text-sm'}>
                                                                    {design[designInfoField?.secondaryAttribute]}
                                                                </div>
                                                            }
                                                        </>
                                                    }
                                                </td>
                                            </React.Fragment>
                                        ))}

                                        <td className="p-2 border border-gray-400 m-auto w-96">
                                            <div className="flex flex-wrap justify-start items-center">

                                                <div className="flex justify-around">
                                                    <CopyDataToClipboard
                                                        sizeClass={'px-0 py-1'}
                                                        value={JSON.stringify(design, null, 2)}/>
                                                </div>

                                                {selectedDesignInfo?.id === design?.id &&
                                                    <div className="mx-2">
                                                        <ShowProgressSpinner
                                                            sizeClass={'h-6 w-6'}
                                                            dataFetchInProgress={true}/>
                                                    </div>
                                                }

                                                <div className={'flex ml-2'}>
                                                    <AddEditImageMedia
                                                        isAddImageMedia={true}
                                                        mediaFor={design}
                                                        cssClass={'button-green-outline text-sm px-2 py-1 flex items-center justify-center'}
                                                        refreshImageMediaList={() => {
                                                        }}/>
                                                </div>

                                                {/* <div className={'flex ml-2'}>
                                                    <AddEditPinterestImages
                                                        isAddImageMedia={true}
                                                        designInfo={design}
                                                        designDetail={designDetail}
                                                        cssClass={'button-sky-outline text-sm px-2 py-1 flex items-center justify-center'}
                                                        afterSaveAction={() => {
                                                        }}/>
                                                </div>*/}

                                                {!design?.hasTags &&
                                                    <div>
                                                        <button
                                                            className={`button-green-outline text-sm px-1 py-0 flex items-center justify-center 
                                                            ${selectedDesignInfo?.id === design?.id ? 'cursor-not-allowed button-gray-outline-disabled' : ''}`}
                                                            disabled={selectedDesignInfo?.id === design?.id}
                                                            onClick={() => {
                                                                handleUpdateDesignTags(design)
                                                            }}>
                                                            <PlusIcon className="h-4 w-4"/>
                                                            <span className={'mr-1'}>Tags</span>
                                                        </button>
                                                    </div>
                                                }

                                                {design?.hasDuplicateMetaTitle &&
                                                    <div className={'flex ml-2'}>
                                                        <button
                                                            className={`button-green-outline text-sm px-1 py-1 flex items-center justify-center 
                                                            ${selectedDesignInfo?.id === design?.id ? 'cursor-not-allowed button-gray-outline-disabled' : ''}`}
                                                            disabled={selectedDesignInfo?.id === design?.id}
                                                            onClick={() => {
                                                                fixDuplicateMetaTitles(design)
                                                            }}>
                                                            <WrenchScrewdriverIcon className="h-4 w-4 ml-1"/>
                                                            <span className={'mx-1'}>Meta Title</span>
                                                        </button>
                                                    </div>
                                                }

                                                {!design?.hasBlogPost &&
                                                    <div className={'flex ml-2'}>
                                                        <button
                                                            className={`button-green-outline text-sm px-1 py-1 flex items-center justify-center 
                                                            ${selectedDesignInfo?.id === design?.id ? 'cursor-not-allowed button-gray-outline-disabled' : ''}`}
                                                            disabled={selectedDesignInfo?.id === design?.id}
                                                            onClick={() => {
                                                                generateBlogPostTitles(design)
                                                            }}>
                                                            <Bars3BottomLeftIcon className="h-4 w-4 ml-1"/>
                                                            <span className={'mx-1'}>Blog Title</span>
                                                        </button>
                                                    </div>
                                                }
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>

                        </div>
                    }
                </div>

            </div>

        </>
    )
}

export default DesignInfoList

